import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicContentApi } from "../api/api";
import "./Terms.css";

const Terms = () => {
  const [projectTitle, setProjectTitle] = useState("خبرخوان");
  const [termsText, setTermsText] = useState(
    "استفاده از این سامانه به معنای پذیرش قوانین مربوط به حریم خصوصی، امنیت حساب کاربری و استفاده مسئولانه از داده های خبری است. لطفا اطلاعات ورود خود را محرمانه نگه دارید و از انتشار محتوای غیرمجاز خودداری کنید."
  );

  useEffect(() => {
    let isCancelled = false;
    const fetchTerms = async () => {
      try {
        const result = await publicContentApi.getHomepageConfig();
        if (!isCancelled) {
          setProjectTitle(String(result?.project_title || "خبرخوان"));
          if (String(result?.terms_and_conditions || "").trim()) {
            setTermsText(String(result?.terms_and_conditions || ""));
          }
        }
      } catch (error) {
        // Keep defaults when endpoint is unreachable.
      }
    };
    fetchTerms();
    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <main className="terms-page">
      <section className="terms-card">
        <h1 className="terms-title">قوانین و مقررات {projectTitle}</h1>
        <p className="terms-text">{termsText}</p>
        <Link to="/" className="terms-back">
          بازگشت به صفحه اصلی
        </Link>
      </section>
    </main>
  );
};

export default Terms;
